export const setActiveRecommendation = recommendation => {
  return {
    type: 'SET_ACTIVE_RECOMMENDATION',
    payload: {
      recommendation,
    },
  };
};
